import { Alert, Button, Modal, ModalProps } from '@payaca/ambrosia';
import { singularPlural } from '@payaca/utilities/stringUtilities';
import { FC } from 'react';
import useUnshareFolderEntries from '../../../../../../api/mutations/project/useUnshareFolderEntries';
import { TFolderEntry } from '../../../../../../api/queries/project/useGetProjectFolderEntries';

type Props = {
  projectId: string;
  folderEntries: TFolderEntry[];
} & Pick<ModalProps, 'isOpen' | 'onClose'>;

const ShareFilesModal: FC<Props> = (props) => {
  const { folderEntries, projectId, isOpen, onClose } = props;

  const unshareFolderEntriesMutation = useUnshareFolderEntries(projectId, {
    onSuccess: () => {
      onClose?.();
    },
  });

  const handleUnshare = () => {
    unshareFolderEntriesMutation.mutate({
      folderEntryIds: folderEntries.map((entry) => entry.id),
    });
  };

  return (
    <Modal
      title="Are you sure you want to unshare?"
      isOpen={isOpen}
      onClose={onClose}
    >
      <Modal.Body>
        <p className="mb-2 text-base">
          You are about to unshare{' '}
          {singularPlural(folderEntries.length, 'file')} with the customer of
          this project.
        </p>

        <p className="mb-2 text-base">
          This will no longer allow the customer to view and download the files
          via the client portal.
        </p>
      </Modal.Body>

      <Modal.Footer>
        {unshareFolderEntriesMutation.isError && (
          <Alert colour="red" className="mb-4">
            Failed to unshare files. Please try again.
          </Alert>
        )}
        <Modal.Footer.Actions>
          <Button
            className="mr-2"
            variant={'outline'}
            disabled={unshareFolderEntriesMutation.isPending}
            onClick={onClose}
          >
            Cancel
          </Button>
          <Button
            onClick={handleUnshare}
            disabled={unshareFolderEntriesMutation.isPending}
            isProcessing={unshareFolderEntriesMutation.isPending}
          >
            Unshare
          </Button>
        </Modal.Footer.Actions>
      </Modal.Footer>
    </Modal>
  );
};

export default ShareFilesModal;
